export const REPORT_TEST_IDS = {
  reportLoader: 'report-loader',
  listReportContainer: 'list-report-container',
  listReportProjectName: 'list-report-project-name',
  listReportCompanyName: 'list-report-company-name',
  listReportStageName: 'list-report-stage-name',
  listReportUnions: 'list-report-unions',
  listReportWorkingLocation: 'list-report-working-location',
  listReportHeightWeight: 'list-report-height-weight',
  listReportPhone: 'list-report-phone',
  listReportRepresentation: 'list-report-representation',
  listReportCredits: 'list-report-credits',
  listReportNote: 'list-report-note',
  listReportDate: 'list-report-date',
  listReportError: 'list-report-error',
  listReportLuminateDateOfBirth: 'list-report-luminate-date-of-birth',
  listReportLuminateCountryOfOrigin: 'list-report-luminate-country-of-origin',
  listReportLuminateScreenScore: 'list-report-luminate-ScreenScore',
  listReportLuminatePronounce: 'list-report-luminate-pronounce',
};
